import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { withRouter } from 'react-router-dom'

import './custom-select.css'

export const CustomSelect = withRouter((props) => {
  const { options = [], value, children, onChange, body, history, className, iconColor = '1d8edf' } = props
  const [isOpen, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(value);
  
  const toggleDropdown = () => setOpen((prevOpen) => !prevOpen)

  useEffect(() => {
    if (value) {
      setSelectedItem(value)
    }
  }, [value])

  useEffect(() => {
    setOpen(false)
  }, [history.location.pathname, history.location.search])
  
  const handleItemClick = (id) => {
    const newId = String(selectedItem) === String(id) ? '' : id
    setSelectedItem(newId)
    onChange && onChange(newId)
    setOpen(false)
  }

  const dropdownBodyClasses = classNames('custom-select__dropdown-body', { 'open': isOpen })
  const dropdownClasses = classNames('custom-select__dropdown', className)
  
  return (
    <div className={dropdownClasses}>
      <div
        className='custom-select__dropdown-head'
        onClick={toggleDropdown}
      >
        {children}
        <img
          style={{
            marginLeft: 3,
            marginTop: 3,
            transform: isOpen ? 'rotate(180deg)': ''
          }}
          src={`https://img.icons8.com/ios-filled/50/${iconColor}/chevron-down.png`}
          width={10}
          height={10}
          alt='arrow-down'
        />
      </div>
      <div className={dropdownBodyClasses}>
        {options.map((item) => (
          <div
            className="custom-select__dropdown__item"
            onClick={onChange && (() => handleItemClick(item.value))}
            key={`${item.value}`}
          >
            <span className={classNames('custom-select__dropdown__item-dot', { 'selected': item.value === selectedItem })}>• </span>
            {item.label}
          </div>
        ))}
        {body}
      </div>
    </div>
  )
})
